import type { Router, RouteLocationRaw } from 'vue-router'
import { isMac, isWindows } from '@lib/util/userAgents'

export async function navigateTo(
  router: Router,
  routeData: RouteLocationRaw,
  client: 'admin' | 'impact',
  options?: { newTab?: boolean; target?: string },
) {
  const { newTab, target = '_blank' } = options || {}
  if (newTab) {
    const routerResolve = router.resolve(routeData)
    const routePath = client === 'admin' ? routerResolve.href : routerResolve.fullPath
    window.open(routePath, target)
  } else {
    await router.push(routeData)
  }
}

export function isModifierClick(e?: MouseEvent) {
  return (isWindows && e?.ctrlKey) || (isMac && e?.metaKey)
}
